import axios from 'axios';
import has from 'lodash/has.js';

const tokens = {};

/**
 * True when the error is from Axios aborting a request (superseded autosave, navigation, etc.).
 * Covers axios@0.x CancelToken and axios@1.x CanceledError / ERR_CANCELED.
 */
export function isAxiosCancel(error) {
    if (!error) {
        return false;
    }
    if (typeof axios.isCancel === 'function' && axios.isCancel(error)) {
        return true;
    }
    if (error.code === 'ERR_CANCELED') {
        return true;
    }
    const msg = String(error.message || '').toLowerCase();
    return msg === 'canceled' || msg === 'cancelled';
}

const cancelSource = mutation => {
    const cancelKeyRaw = typeof mutation === 'string' ? mutation : mutation?.type;
    const cancelKey = cancelKeyRaw != null && cancelKeyRaw !== '' ? cancelKeyRaw : '__CancelSource_missing_type__';

    if (has(tokens, cancelKey) && tokens[cancelKey]) {
        tokens[cancelKey].cancel();
    }

    const source = axios.CancelToken.source();
    tokens[cancelKey] = source;

    return {
        source,
        axiosConfig: {
            cancelToken: source.token,
        },
    };
};

export const errorHandler = mutation => {
    return (error, store) => {
        if (isAxiosCancel(error)) {
            // Request canceled, do nothing
        } else {
            console.error('There was a problem: ', error);

            // Handle error
            if (store) {
                store.dispatch('AutoSave/setError', {
                    indicator: mutation,
                    error,
                });
            }
        }
    };
};

export default cancelSource;
